import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { DevCard } from '../components/DevCard';
import { devPosts } from '../data/devPosts';

export function renderDevsPage(): string {
  const devCardsHtml = devPosts.map(p => DevCard(p)).join('');

  return /*html*/`
    ${Header()}
    
    <main class="fade-in">
      <!-- Devs Hero Header -->
      <section style="position: relative; padding: 5rem 0 4rem; overflow: hidden; background: radial-gradient(circle at 50% 20%, rgba(0, 210, 255, 0.15) 0%, rgba(7, 8, 13, 0.95) 75%); border-bottom: 1px solid rgba(0, 210, 255, 0.2);">
        <div style="position: absolute; inset: 0; opacity: 0.18; pointer-events: none;">
          <img src="/images/brand/atomix-dev-banner.jpg" alt="AtomixDevs Workspace" style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
        
        <div class="container" style="position: relative; z-index: 1; text-align: center; max-width: 850px;">
          <div class="badge badge-cyan" style="margin-bottom: 1rem;">
            <sl-icon name="code-slash"></sl-icon>
            <span>AtomixDevs Division</span>
          </div>
          <h1 style="font-size: clamp(2.2rem, 5vw, 3.5rem); margin-bottom: 1.25rem;">
            Vibe Coding & <span class="text-gradient">Deep Architecture</span>
          </h1>
          <p style="font-size: 1.15rem; color: #cbd5e1; line-height: 1.6; margin-bottom: 2rem;">
            Exploring generative AI assisted engineering ("Vibe Coding"), mathematical fractal shaders, distributed game engine ECS designs, and technical deep-dives directly from <strong>mydevblog</strong>.
          </p>

          <div style="display: flex; justify-content: center; gap: 1rem; flex-wrap: wrap;">
            <a href="https://atomixnmc.github.io/mydevblog/" target="_blank" rel="noopener noreferrer" class="btn-cyber" style="background: linear-gradient(135deg, #00d2ff 0%, #3a7bd5 100%);">
              <sl-icon name="journal-code"></sl-icon>
              <span>Visit mydevblog Live</span>
            </a>
            <a href="https://github.com/atomixnmc" target="_blank" rel="noopener noreferrer" class="btn-ghost">
              <sl-icon name="github"></sl-icon>
              <span>Founder GitHub (@atomixnmc)</span>
            </a>
          </div>
        </div>
      </section>

      <!-- Vibe Coding & Core Engineering Focus -->
      <section class="container" style="padding: 4.5rem 1.5rem 2rem;">
        <div class="grid grid-3" style="gap: 1.5rem;">
          <div class="glass-panel" style="padding: 1.75rem; border-top: 3px solid #00d2ff;">
            <div style="font-size: 1.8rem; margin-bottom: 0.75rem;">⚡</div>
            <h3 style="font-size: 1.2rem; margin-bottom: 0.5rem;">Vibe Coding & AI Pairs</h3>
            <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Harnessing autonomous agentic coding, high-level system reasoning, and prompt engineering to turn vision into robust production code at light speed.
            </p>
          </div>
          <div class="glass-panel" style="padding: 1.75rem; border-top: 3px solid #3b82f6;">
            <div style="font-size: 1.8rem; margin-bottom: 0.75rem;">🌀</div>
            <h3 style="font-size: 1.2rem; margin-bottom: 0.5rem;">Fractals & Compute Math</h3>
            <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Pushing GPU shaders to generate infinite recursive Mandelbrot, Julia sets, and 3D volumetric raymarching worlds in real-time.
            </p>
          </div>
          <div class="glass-panel" style="padding: 1.75rem; border-top: 3px solid #8b5cf6;">
            <div style="font-size: 1.8rem; margin-bottom: 0.75rem;">🏗️</div>
            <h3 style="font-size: 1.2rem; margin-bottom: 0.5rem;">Scalable Game Architecture</h3>
            <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Designing cache-aligned memory data structures, reactive event buses, and multi-threaded simulation loops for desktop and mobile engines.
            </p>
          </div>
        </div>
      </section>

      <!-- Articles & Tutorials Grid -->
      <section class="container" style="padding: 3.5rem 1.5rem 5rem;">
        <div class="section-header" style="text-align: left; margin-bottom: 2.5rem;">
          <span class="badge badge-cyan" style="margin-bottom: 0.5rem;">Selected Writings</span>
          <h2 style="font-size: 2rem;">Featured Technical Articles & Tutorials</h2>
          <p style="margin: 0;">In-depth breakdowns from the founder's archive: <a href="https://atomixnmc.github.io/mydevblog/" target="_blank" rel="noopener noreferrer" style="color: #00d2ff; text-decoration: underline;">atomixnmc.github.io/mydevblog</a>.</p>
        </div>
        <div class="grid grid-2">
          ${devCardsHtml}
        </div>
      </section>

    </main>

    ${Footer()}
  `;
}
